/**
 * @file: 历史记录
 * @author: xiaolong.huang@dmall.com
 */

import Visit from '../visit';
import { stackIn } from './stack/stackIn';
import { stackOut } from './stack/stackOut';
import { getStepCount } from './stack/stepCount';
import { historyPop } from './stack/pop';
import { historyShift } from './stack/shift';
import { clear } from './stack/clear';

// 解决循环引用，往公共对象上挂
function mountApi() {
    Visit.History = {
        stackIn,
        stackOut,
        getStepCount,
        historyPop,
        historyShift,
        clear
    };
}

export default {
    stackIn,
    stackOut,
    getStepCount,
    historyPop,
    historyShift,
    clear,
    mountApi
};
